var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'home' },"tag":"a"}},[_c('img',{staticClass:"logo-auth",attrs:{"src":_vm.logo,"alt":"aNewItem Logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }